import { TerminalItemDto } from "./TerminalInfoDto";

export interface IMerchantDto {
  merchantId: string | null,
  merchant: string | null,
  appName: string | null;
  appStatus: string | null,
  pIva: string | null,
  terminalInfo: TerminalItemDto[] | null,
  appCreation?: string | null,
}

export class MerchantDto implements IMerchantDto {
  public merchantId: string | null;
  public merchant: string | null;
  public appName: string | null;
  public appStatus: string | null;
  public pIva: string | null;
  public terminalInfo: TerminalItemDto[] | null;
  public appCreation?: string | null;

  constructor(
    merchantId: string | null,
    merchant: string | null,
    appName: string | null,
    appStatus: string | null,
    pIva: string | null,
    terminalInfo: TerminalItemDto[] | null,
    appCreation?: string | null,

  ) {
    this.merchantId = merchantId;
    this.merchant = merchant;
    this.appName = appName;
    this.appStatus = appStatus;
    this.appCreation = appCreation;
    this.pIva = pIva;
    this.terminalInfo = terminalInfo;
  }
}